module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		usage: 'management',
		resourceConnected: false
	},

	model: {
		forwardFilterChanges: false,
		forceViewChange: false
	},

	events: {
		refresh: {
			type: 'click',
			selector: 'button[data-field-type="refresh"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				if(event.data.component.model.entityTable){
					event.data.component.model.entityTable.refreshData();
				}
			}
		}
	},

	methods: {
		onChange: function(isRelationChange, changeDone, fieldData){
			if(this.model.forwardFilterChanges && this.model.entityTable){
				var data = (this.model.dirtyFields || {}).data || {};
				var attributes = data.attributes || {};

				this.model.entityTable.onFilterChanged(
					attributes,
					isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
					isRelationChange ? (fieldData || {}).isLastRelationElement : false
				);
			}
		},
		submit: function(){}
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_events_participants_controller', function(controller){
					self.model.controller = controller;
				});
			}
			if(!self.model.entityTable && self.model.controller){
				self.model.controller.find('templates_events_participants_table_table', function(table){
					self.model.entityTable = table;
				});
			}

			this.model.forwardFilterChanges = true;
			if(this.config.usage === 'selection' || Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
				this.model.forceViewChange = true;
				this.onChange();
				this.model.forceViewChange = false;
			}
		},

		colTagsBubbleSelected: function($element, options){
			var self = this;
			options = options || {}

			if(!self.model.tagPickerButtonComponent){
				self.model.tagPickerButtonComponent = getComponent($element.find('.fieldOf_tags > .base_form_fields_tag-picker-button'))
			}
			if(self.model.tagPickerButtonComponent){
				self.model.tagPickerButtonComponent.tagToggle(options.categoryID, options.categoryDataID)
			}
		}
	}
}
